import upstriveLogo from '../upstrive_education_logo.png'
import { ProgressBar } from 'react-loader-spinner'
import { ReactComponent as AlkalmaLogo } from '../AlkalmaLogoWhiteOnBlue.svg'
export default function LandingPage(props) {
    return (
        <div className="landing-page-container">
            <div className="landing-page-body">
                <AlkalmaLogo className="login-image" height={200} />
                <ProgressBar height="80" width="80" ariaLabel="progress-bar-loading" wrapperStyle={{}} wrapperClass="progress-bar-wrapper" borderColor="#FFF" barColor="#7ec5c6" />
            </div>
        </div>
    )
}
